// Re-exports the shared policy from @swiss-magic/shared-types so
// frontend code can keep importing from @/lib/passwordPolicy while
// the actual rule stays in one place (used by the backend too).

export {
  PASSWORD_MIN_LENGTH,
  isPasswordValid,
} from '@swiss-magic/shared-types';
import { isPasswordValid } from '@swiss-magic/shared-types';

// Keep the old name working for existing call sites.
export function validatePassword(password: string): boolean {
  return isPasswordValid(password);
}
